var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "validation-observer",
    { ref: "deliverVardObserver", attrs: { novalidate: "", tag: "form" } },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12 text-bold bold mb-3" }, [
          _c("i", { staticClass: "fa fa-user-check color-orange" }),
          _vm._v(" Entregada a Encargado ")
        ]),
        _c(
          "div",
          { staticClass: "col-md-3" },
          [
            _c("validation-provider", {
              attrs: { rules: "required" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function({ errors }) {
                    return [
                      _c("custom-date-picker", {
                        staticClass: "custom-date-picker__extended",
                        attrs: {
                          "custom-error-msg":
                            "Favor seleccionar Fecha de Entrega.",
                          error: errors[0],
                          label: "Fecha:",
                          "max-date": new Date(),
                          "min-date": _vm.beforeBankRequestDate,
                          placeholder: "DD/MM/YYYY"
                        },
                        model: {
                          value: _vm.model.deliveryDate,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "deliveryDate", $$v)
                          },
                          expression: "model.deliveryDate"
                        }
                      })
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md-3" },
          [
            _c("validation-provider", {
              attrs: { rules: "required" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function({ errors }) {
                    return [
                      _c("custom-drop-down", {
                        attrs: {
                          clearable: false,
                          "custom-error-msg":
                            "Favor seleccionar Método de Entrega.",
                          error: errors[0],
                          fieldkey: "id",
                          fieldname: "name",
                          label: "Método de Entrega:",
                          options: _vm.deliveryMethods,
                          placeholder: "Seleccione"
                        },
                        model: {
                          value: _vm.model.deliveryMethodId,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "deliveryMethodId", $$v)
                          },
                          expression: "model.deliveryMethodId"
                        }
                      })
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md-12 mt-2" },
          [
            _c("custom-text-area", {
              attrs: {
                label: "Comentario:",
                maxlength: 500,
                rows: 4,
                "show-char-count": ""
              },
              model: {
                value: _vm.model.comment,
                callback: function($$v) {
                  _vm.$set(_vm.model, "comment", $$v)
                },
                expression: "model.comment"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md-12 text-right mt-3 pt-1" },
          [
            _c(
              "action-button",
              {
                attrs: {
                  i: "fas fa-times-circle",
                  variant: "outline-danger mr-3"
                },
                on: {
                  click: function($event) {
                    return _vm.$emit("on-cancel")
                  }
                }
              },
              [_vm._v(" Cancelar ")]
            ),
            _c(
              "action-button",
              {
                attrs: { i: "fas fa-save", variant: "success" },
                on: { click: _vm.submit }
              },
              [_vm._v(" Guardar ")]
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }